// extracted by mini-css-extract-plugin
export default {"list_item":"medicineNotebook_list_item__Pj6Je","list_item_year":"medicineNotebook_list_item_year__X5ig4"};